export default __webpack_public_path__ + "static/media/box_detail.213d8437.png";